(function () {
  function wrapList(card) {
    var list = card.querySelector(".kit-list");
    if (!list) return null;

    if (list.parentElement && list.parentElement.classList.contains("kit-list-wrap")) {
      return list.parentElement;
    }

    var wrap = document.createElement("div");
    wrap.className = "kit-list-wrap";
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);

    return wrap;
  }

  function moveFadeIntoWrap(card, wrap) {
    var fade = card.querySelector(".kit-fade");
    if (!fade) return;

    if (fade.parentElement !== wrap) {
      wrap.appendChild(fade);
    }
  }

  function getWrapHeight(wrap) {
    var prev = wrap.style.maxHeight;
    wrap.style.maxHeight = "none";
    var h = wrap.scrollHeight;
    wrap.style.maxHeight = prev;
    return h;
  }

  function showHiddenRows(card) {
    var rows = card.querySelectorAll(
      '[data-kit-summary-hidden="true"], [data-bom-hidden="true"], [data-toolkit-hidden="true"]'
    );

    rows.forEach(function (r) {
      r.classList.remove("kit-row--hidden");
      r.classList.remove("kit-row--toolkit-hidden");
    });
  }

  function hideRowsAgain(card) {
    var rows = card.querySelectorAll(
      '[data-kit-summary-hidden="true"], [data-bom-hidden="true"], [data-toolkit-hidden="true"]'
    );

    rows.forEach(function (r) {
      if (r.hasAttribute("data-toolkit-hidden")) r.classList.add("kit-row--toolkit-hidden");
      else r.classList.add("kit-row--hidden");
    });
  }

  function enhanceButton(btn) {
    if (btn.dataset.enhanced === "1") return;

    btn.dataset.enhanced = "1";
    btn.setAttribute("type", "button");
    btn.setAttribute("aria-expanded", "false");

    var label = btn.textContent.trim() || "View all";
    btn.dataset.label = label;

    btn.innerHTML =
      '<span class="kit-viewall__text">' + label + '</span>' +
      '<span class="kit-viewall__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      "</span>";
  }

  function setCollapsed(card, wrap, btn) {
    card.classList.remove("is-expanded");
    btn.setAttribute("aria-expanded", "false");
    btn.querySelector(".kit-viewall__text").textContent = btn.dataset.label || "View all";

    hideRowsAgain(card);

    requestAnimationFrame(function () {
      wrap.style.maxHeight = getWrapHeight(wrap) + "px";
    });
  }

  function setExpanded(card, wrap, btn) {
    card.classList.add("is-expanded");
    btn.setAttribute("aria-expanded", "true");
    btn.querySelector(".kit-viewall__text").textContent = "View less";

    showHiddenRows(card);

    requestAnimationFrame(function () {
      wrap.style.maxHeight = getWrapHeight(wrap) + "px";
    });
  }

  function setupTruncatedCard(card) {
    var wrap = wrapList(card);
    if (!wrap) return;

    moveFadeIntoWrap(card, wrap);

    var btn = card.querySelector("[data-kit-viewall]");
    if (!btn) return;

    enhanceButton(btn);

    hideRowsAgain(card);
    wrap.style.maxHeight = getWrapHeight(wrap) + "px";

    btn.addEventListener("click", function () {
      var expanded = card.classList.contains("is-expanded");

      if (expanded) {
        setCollapsed(card, wrap, btn);

        window.setTimeout(function () {
          var target = card.closest(".kit-wrapper") || card;
          var offset = window.innerWidth < 768 ? 90 : 30;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: Math.max(top, 0),
            behavior: "smooth"
          });
        }, 80);
      } else {
        setExpanded(card, wrap, btn);
      }
    });
  }

  function initKitWrappers(root) {
    root = root || document;

    root.querySelectorAll(".kit-wrapper").forEach(function (wrapper) {
      if (wrapper.dataset.bound === "1") return;
      wrapper.dataset.bound = "1";

      var layoutMode = wrapper.getAttribute("data-kit-layout");
      var defaultTab = wrapper.getAttribute("data-kit-default-tab") || "summary";

      wrapper.querySelectorAll(".kit-card--truncated").forEach(setupTruncatedCard);

      if (layoutMode === "tabs") {
        var btns = wrapper.querySelectorAll("[data-kit-tab-btn]");
        var panels = wrapper.querySelectorAll("[data-kit-panel]");

        function activate(name) {
          panels.forEach(function (p) {
            var isActive = p.getAttribute("data-kit-panel") === name;
            p.style.display = isActive ? "" : "none";
          });

          btns.forEach(function (b) {
            b.classList.toggle("is-active", b.getAttribute("data-kit-tab-btn") === name);
          });

          var activePanel = wrapper.querySelector('[data-kit-panel="' + name + '"]');
          if (activePanel && activePanel.classList.contains("kit-card--truncated")) {
            var wrap = activePanel.querySelector(".kit-list-wrap");
            if (wrap) wrap.style.maxHeight = getWrapHeight(wrap) + "px";
          }
        }

        btns.forEach(function (b) {
          b.addEventListener("click", function () {
            activate(b.getAttribute("data-kit-tab-btn"));
          });
        });

        var exists = wrapper.querySelector('[data-kit-panel="' + defaultTab + '"]');
        if (!exists && panels.length) defaultTab = panels[0].getAttribute("data-kit-panel");

        activate(defaultTab);

        /* Toolkit tab state linked to toggle - tab always remains visible */
        var toolkitTabBtn = wrapper.querySelector("[data-kit-toolkit-tab]");
        var toolkitPanel = wrapper.querySelector("[data-kit-toolkit-panel]");

        if (toolkitTabBtn && toolkitPanel) {
          var mainTabBtn =
            wrapper.querySelector('[data-kit-tab-btn="contents"]') ||
            wrapper.querySelector('[data-kit-tab-btn="includes"]') ||
            wrapper.querySelector('[data-kit-tab-btn="summary"]') ||
            wrapper.querySelector("[data-kit-tab-btn]");

          function setToolkitState(added) {
            toolkitTabBtn.classList.remove("is-hidden");
            toolkitPanel.style.display = toolkitTabBtn.classList.contains("is-active") ? "" : toolkitPanel.style.display;

            wrapper.classList.toggle("kit-toolkit-is-added", added);
            toolkitTabBtn.classList.toggle("is-added", added);
            toolkitPanel.classList.toggle("is-added", added);

            var upsell = document.querySelector("[data-toolkit-upsell]");
            if (upsell) {
              upsell.classList.toggle("is-added", added);
              upsell.setAttribute("data-toolkit-state", added ? "added" : "off");
            }
          }

          function getToolkitAdded() {
            var toggle = document.querySelector("[data-toolkit-toggle]");
            return !!(toggle && toggle.checked);
          }

          function updateToolkitState() {
            var added = getToolkitAdded();
            setToolkitState(added);
            return added;
          }

          function openToolkitTab() {
            toolkitTabBtn.classList.remove("is-hidden");
            activate("toolkit");

            window.setTimeout(function () {
              toolkitPanel.style.display = "";
            }, 30);
          }

          function openMainTab() {
            if (mainTabBtn && mainTabBtn !== toolkitTabBtn) {
              activate(mainTabBtn.getAttribute("data-kit-tab-btn"));
            }
          }

          document.addEventListener("change", function (e) {
            if (!e.target || !e.target.matches("[data-toolkit-toggle]")) return;

            var added = updateToolkitState();

            if (added) {
              openToolkitTab();
            } else {
              openMainTab();
            }
          });

          document.addEventListener("click", function (e) {
            var jump = e.target.closest("[data-toolkit-jump]");
            if (!jump) return;

            e.preventDefault();

            openToolkitTab();

            window.setTimeout(function () {
              var offset = window.innerWidth < 768 ? 92 : 32;
              var top = wrapper.getBoundingClientRect().top + window.pageYOffset - offset;

              window.scrollTo({
                top: Math.max(top, 0),
                behavior: "smooth"
              });
            }, 60);
          });

          updateToolkitState();
          setTimeout(updateToolkitState, 300);
          setTimeout(updateToolkitState, 1200);
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initKitWrappers(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    initKitWrappers(e.target);
  });
})();
/* ======================================================
   FRK enriched kit contents accordion
====================================================== */

(function () {
  function initKitContents(root) {
    root = root || document;

    root.querySelectorAll("[data-kit-contents]").forEach(function (card) {
      if (card.dataset.contentsBound === "1") return;
      card.dataset.contentsBound = "1";

      card.querySelectorAll("[data-kit-group-toggle]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var group = btn.closest("[data-kit-content-group]");
          if (!group) return;

          var panelId = btn.getAttribute("aria-controls");
          var panel = panelId ? document.getElementById(panelId) : null;
          if (!panel) return;

          var isOpen = btn.getAttribute("aria-expanded") === "true";

          btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
          group.classList.toggle("is-open", !isOpen);
          panel.hidden = isOpen;
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initKitContents(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    initKitContents(e.target);
  });
})();

/* ======================================================
   FRK grouped toolkit categories - View all / View less
====================================================== */

(function () {
  function initToolkitCategoryViewAll(root) {
    root = root || document;

    root.querySelectorAll("[data-kit-category-viewall]").forEach(function (btn) {
      if (btn.dataset.categoryViewallBound === "1") return;
      btn.dataset.categoryViewallBound = "1";

      btn.addEventListener("click", function () {
        var card = btn.closest(".kit-card");
        if (!card) return;

        var isOpen = card.classList.toggle("is-category-expanded");

        var text = btn.querySelector(".kit-viewall__text");
        if (text) text.textContent = isOpen ? "View less" : "View all tools";

        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });

      btn.setAttribute("aria-expanded", "false");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initToolkitCategoryViewAll(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    initToolkitCategoryViewAll(e.target);
  });
})();

/* ======================================================
   FRK coverage bottom sheet
====================================================== */

(function () {
function openSheet(sheet, trigger) {
  if (!sheet) return;

  /* Move modal to body so it escapes PDP/header stacking issues */
  if (sheet.parentElement !== document.body) {
    document.body.appendChild(sheet);
  }

  sheet.hidden = false;
  sheet.__coverageTrigger = trigger || null;

  /* Always open from top */
  sheet.scrollTop = 0;

  var panel = sheet.querySelector(".kit-coverage-sheet__panel");
  if (panel) {
    panel.scrollTop = 0;
  }

  document.documentElement.classList.add("kit-coverage-sheet-open");
  document.body.classList.add("kit-coverage-sheet-open");

  requestAnimationFrame(function () {
    sheet.classList.add("is-open");

    var closeBtn = sheet.querySelector("[data-kit-coverage-close]");
    if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
  });
}

  function closeSheet(sheet) {
    if (!sheet) return;

    sheet.classList.remove("is-open");

    window.setTimeout(function () {
      sheet.hidden = true;

      document.documentElement.classList.remove("kit-coverage-sheet-open");
      document.body.classList.remove("kit-coverage-sheet-open");

      if (sheet.__coverageTrigger && sheet.__coverageTrigger.focus) {
        sheet.__coverageTrigger.focus({ preventScroll: true });
      }

      sheet.__coverageTrigger = null;
    }, 220);
  }

  function initCoverageSheets(root) {
    root = root || document;

    root.querySelectorAll("[data-kit-coverage-open]").forEach(function (btn) {
      if (btn.dataset.coverageBound === "1") return;
      btn.dataset.coverageBound = "1";

      btn.addEventListener("click", function () {
        var id = btn.getAttribute("aria-controls");
        var sheet = id ? document.getElementById(id) : null;
        openSheet(sheet, btn);
      });
    });

    root.querySelectorAll("[data-kit-coverage-sheet]").forEach(function (sheet) {
      if (sheet.dataset.coverageSheetBound === "1") return;
      sheet.dataset.coverageSheetBound = "1";

      sheet.querySelectorAll("[data-kit-coverage-close]").forEach(function (closeBtn) {
        closeBtn.addEventListener("click", function () {
          closeSheet(sheet);
        });
      });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    document.querySelectorAll("[data-kit-coverage-sheet].is-open").forEach(function (sheet) {
      closeSheet(sheet);
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    initCoverageSheets(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    initCoverageSheets(e.target);
  });
})();
/* ======================================================
   FRK coverage sheet - click outside panel to close
====================================================== */

(function () {
  document.addEventListener("click", function (e) {
    var openSheet = document.querySelector("[data-kit-coverage-sheet].is-open");
    if (!openSheet) return;

    var panel = openSheet.querySelector(".kit-coverage-sheet__panel");
    if (!panel) return;

    var clickedOpenButton = e.target.closest("[data-kit-coverage-open]");
    if (clickedOpenButton) return;

    var clickedInsidePanel = panel.contains(e.target);

    if (!clickedInsidePanel) {
      openSheet.classList.remove("is-open");

      window.setTimeout(function () {
        openSheet.hidden = true;
        document.documentElement.classList.remove("kit-coverage-sheet-open");
        document.body.classList.remove("kit-coverage-sheet-open");
      }, 220);
    }
  });
})();
/* ======================================================
   FRK BOM product hydration fallback
   Fixes late BOM rows where Liquid all_products hits limits
====================================================== */

(function () {
  var productCache = {};

  function getHandleFromHref(href) {
    if (!href) return "";

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^\/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : "";
    } catch (e) {
      var fallback = String(href).match(/\/products\/([^\/?#]+)/);
      return fallback && fallback[1] ? decodeURIComponent(fallback[1]) : "";
    }
  }

  function getRootUrl() {
    var root = "/";

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      root = Shopify.routes.root;
    }

    if (root.slice(-1) !== "/") root += "/";
    return root;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);

    if (productCache[handle]) {
      return productCache[handle];
    }

    productCache[handle] = fetch(getRootUrl() + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin"
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function getRowHandle(row) {
    if (!row) return "";

    if (row.matches("a[href]")) {
      return getHandleFromHref(row.getAttribute("href"));
    }

    /*
      Expandable parent rows are buttons, so they have no href.
      Use first child product link as the representative image.
    */
    var group = row.closest("[data-kit-content-group]");
    var firstChildLink = group ? group.querySelector(".kit-content-child__link[href]") : null;

    if (firstChildLink) {
      return getHandleFromHref(firstChildLink.getAttribute("href"));
    }

    return "";
  }

  function updateImage(row, product) {
    if (!row || !product || !product.featured_image) return;

    var thumb = row.querySelector(".kit-content-thumb, .kit-content-child__thumb, .kit-thumb");
    if (!thumb) return;

    var img = thumb.querySelector("img");

    if (!img) {
      img = document.createElement("img");
      img.width = 46;
      img.height = 46;
      img.loading = "lazy";
      thumb.innerHTML = "";
      thumb.appendChild(img);
    }

    // Thumbnail-sized image; skip the download when the server already rendered this image
    var full = product.featured_image;
    var base = function (u) { return (u || "").split("?")[0].replace(/^https?:/, "").replace(/^\/\/[^/]+/, ""); };
    if (img.getAttribute("src") && base(img.getAttribute("src")).split("/").pop() === base(full).split("/").pop()) {
      img.alt = img.alt || product.title || "";
      return;
    }
    img.src = full + (full.indexOf("?") > -1 ? "&" : "?") + "width=120";
    img.alt = product.title || "";
  }

 function updateTitle(row, product) {
  if (!row || !product || !product.title) return;

  /*
    For category parent buttons like "Rollers" / "Handles",
    keep the category title.
  */
  if (row.matches("button")) return;

  var childTitle = row.querySelector(".kit-content-child__title");
  var oldKitTitle = row.querySelector(".kit-row-title");

  if (childTitle) {
    childTitle.textContent = product.title;
    return;
  }

  if (oldKitTitle) {
    oldKitTitle.textContent = product.title;
    return;
  }

  /*
    Do NOT overwrite enriched single parent subtitles.
    Liquid handles cleaned subtitles for rows like Topcoat:
    "Stronghold Roofing Topcoat (10kg)"
    instead of repeating colour/RAL.
  */
}

  function hydrateBomRows(root) {
    root = root || document;

    var rows = root.querySelectorAll(
      ".kit-wrapper .kit-content-row, " +
      ".kit-wrapper .kit-content-child__link, " +
      ".kit-wrapper .kit-row-link"
    );

    rows.forEach(function (row) {
      var handle = getRowHandle(row);
      if (!handle) return;

      if (row.dataset.frkHydratedHandle === handle) return;
      row.dataset.frkHydratedHandle = handle;

      fetchProduct(handle).then(function (product) {
        if (!product) return;

        updateImage(row, product);
        updateTitle(row, product);
      });
    });
  }

  // Hydrate when the kit contents come into view, not on page load (saves a request per row on mobile)
  document.addEventListener("DOMContentLoaded", function () {
    var wraps = document.querySelectorAll(".kit-wrapper");
    if (!wraps.length) return;
    if (!("IntersectionObserver" in window)) { hydrateBomRows(document); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        hydrateBomRows(entry.target.parentNode || document);
      });
    }, { rootMargin: "300px 0px" });
    wraps.forEach(function (w) { io.observe(w); });
  });

  document.addEventListener("shopify:section:load", function (e) {
    hydrateBomRows(e.target);
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-kit-group-toggle]")) return;

    window.setTimeout(function () {
      hydrateBomRows(document);
    }, 60);
  });
})();
/* ======================================================
   FRK carousel kit card -> exact BOM row jump
====================================================== */

(function () {
  function getOffset() {
    return window.innerWidth < 768 ? 104 : 36;
  }

  function openContentsTab(wrapper) {
    if (!wrapper) return;

    var btn = wrapper.querySelector('[data-kit-tab-btn="contents"]');
    if (btn && !btn.classList.contains("is-active")) {
      btn.click();
    }
  }

  function openBomGroup(target) {
    if (!target) return;

    var toggle = target.querySelector("[data-kit-group-toggle]");
    if (!toggle) return;

    var expanded = toggle.getAttribute("aria-expanded") === "true";
    if (!expanded) {
      toggle.click();
    }
  }

  function highlightRow(target) {
    if (!target) return;

    target.classList.remove("frk-bom-row-highlight");

    window.setTimeout(function () {
      target.classList.add("frk-bom-row-highlight");
    }, 20);

    window.setTimeout(function () {
      target.classList.remove("frk-bom-row-highlight");
    }, 1600);
  }

  function scrollToTarget(target) {
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset - getOffset();

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: "smooth"
    });

    highlightRow(target);
  }

  function jumpToBomRow(groupKey) {
    var wrapper = document.querySelector(".kit-wrapper");
    if (!wrapper) return;

    openContentsTab(wrapper);

    window.setTimeout(function () {
      var target = wrapper.querySelector('[data-frk-bom-row="' + groupKey + '"]');

      if (!target) {
        scrollToTarget(wrapper);
        return;
      }

      openBomGroup(target);

      window.setTimeout(function () {
        scrollToTarget(target);
      }, 80);
    }, 80);
  }

  function jumpToBomSection() {
    var wrapper = document.querySelector(".kit-wrapper");
    if (!wrapper) return;

    openContentsTab(wrapper);

    window.setTimeout(function () {
      scrollToTarget(wrapper);
    }, 80);
  }

  document.addEventListener("click", function (e) {
    var rowJump = e.target.closest("[data-frk-kit-jump]");
    var allJump = e.target.closest("[data-frk-kit-jump-all]");

    if (!rowJump && !allJump) return;

    e.preventDefault();
    e.stopPropagation();

    if (rowJump) {
      jumpToBomRow(rowJump.getAttribute("data-frk-kit-jump"));
      return;
    }

    jumpToBomSection();
  });
})();
/* ======================================================
   FRK outer BOM accordion
   Expanded by default on mobile; user choice persists for
   the current browser session. Desktop always stays open.
====================================================== */
(function () {
  var MOBILE_QUERY = '(max-width: 640px)';

  function storageKey(wrapper) {
    var key = wrapper.getAttribute('data-kit-bom-collapse-key') || 'product';
    return 'frk-bom-collapsed:' + key;
  }

  function readStored(wrapper) {
    try {
      return window.sessionStorage.getItem(storageKey(wrapper)) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeStored(wrapper, collapsed) {
    try {
      window.sessionStorage.setItem(storageKey(wrapper), collapsed ? '1' : '0');
    } catch (e) {}
  }

  function setImmediate(content, expanded) {
    content.style.transition = 'none';
    content.hidden = false;
    content.style.maxHeight = expanded ? 'none' : '0px';
    content.style.opacity = expanded ? '1' : '0';
    // Force layout before restoring transitions.
    content.offsetHeight;
    content.style.transition = '';
  }

  function setState(wrapper, expanded, options) {
    options = options || {};

    var toggle = wrapper.querySelector(':scope > [data-kit-outer-toggle]');
    var content = wrapper.querySelector(':scope > [data-kit-outer-content]');
    if (!toggle || !content) return;

    var isMobile = window.matchMedia(MOBILE_QUERY).matches;

    // Desktop always remains fully visible.
    if (!isMobile) {
      wrapper.classList.remove('is-bom-collapsed');
      toggle.setAttribute('aria-expanded', 'true');
      content.hidden = false;
      content.style.maxHeight = 'none';
      content.style.opacity = '1';
      return;
    }

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    wrapper.classList.toggle('is-bom-collapsed', !expanded);

    if (options.immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setImmediate(content, expanded);
    } else if (expanded) {
      content.hidden = false;
      content.style.opacity = '0';
      content.style.maxHeight = '0px';

      window.requestAnimationFrame(function () {
        content.style.opacity = '1';
        content.style.maxHeight = content.scrollHeight + 'px';
      });

      window.setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          content.style.maxHeight = 'none';
        }
      }, 320);
    } else {
      if (content.style.maxHeight === 'none' || !content.style.maxHeight) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      window.requestAnimationFrame(function () {
        content.style.opacity = '0';
        content.style.maxHeight = '0px';
      });
    }

    if (options.persist) writeStored(wrapper, !expanded);
  }

  function initOuterBom(root) {
    root = root || document;

    root.querySelectorAll('.kit-wrapper[data-kit-bom-collapse-key]').forEach(function (wrapper) {
      if (wrapper.dataset.outerBomBound === '1') return;
      wrapper.dataset.outerBomBound = '1';

      var toggle = wrapper.querySelector(':scope > [data-kit-outer-toggle]');
      var content = wrapper.querySelector(':scope > [data-kit-outer-content]');
      if (!toggle || !content) return;

      // Expanded is the default; only a deliberate session choice collapses it.
      setState(wrapper, !readStored(wrapper), { immediate: true });

      toggle.addEventListener('click', function () {
        var currentlyExpanded = toggle.getAttribute('aria-expanded') === 'true';
        setState(wrapper, !currentlyExpanded, { persist: true });
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          setState(wrapper, !readStored(wrapper), { immediate: true });
        }, 120);
      }, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOuterBom(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initOuterBom(event.target);
  });
})();
